import React, { useState, FC, useRef } from "react";
import { Select, SelectProps as AntdSelectProps, Spin } from "antd";
import styles from "./infinite-scroll-select.module.css";
import { useEffect } from "react";
import { SelectProps } from "rc-select";
import { useDebouncedCallback } from "use-debounce";

const { ["infinite-scroll-select"]: infiniteScrollSelect } = styles as any;

type OptionsType = Pick<SelectProps, "options">["options"];

export type InfiniteScrollSelectProps<T> = AntdSelectProps<T> & {
  onLoadMore?: () => Promise<OptionsType | void> | OptionsType | void;
};

export const InfiniteScrollSelect: FC<InfiniteScrollSelectProps<any | any[]>> = ({
  onLoadMore,
  onPopupScroll,
  options: optionsRaw = [],
  ...args
}) => {
  const [options, setOptions] = useState<OptionsType>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const bottomRef = useRef<null | HTMLDivElement>(null);

  const opts = options;

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [loading, options]);

  const debounceScroll = useDebouncedCallback(async () => {
    if (onLoadMore) {
      const loadMoreRes = await onLoadMore();

      if (loadMoreRes) {
        setOptions(loadMoreRes);
      }
    }

    setLoading(false);
  }, 1000);

  const doOnPopupScroll = async (event: any) => {
    if (onLoadMore) {
      const target = event.target as HTMLElement;
      const { scrollTop, offsetHeight, scrollHeight } = target;

      if (!loading && scrollTop + offsetHeight === scrollHeight) {
        setLoading(true);
        debounceScroll();
      }
    }

    return onPopupScroll && onPopupScroll(event);
  };

  useEffect(() => {
    setOptions(optionsRaw);
  }, [optionsRaw]);

  return (
    <div className={infiniteScrollSelect}>
      <Select
        {...args}
        onPopupScroll={doOnPopupScroll}
        loading={loading}
        options={opts}
        dropdownRender={
          loading
            ? (menus) => (
                <div>
                  {args.dropdownRender && args.dropdownRender(menus)}
                  <span ref={bottomRef} className={styles["spin"]}>
                    <Spin style={{}} />
                  </span>
                </div>
              )
            : (menus) => {
                return (
                  <div>
                    {args.dropdownRender && args.dropdownRender(menus)}
                    <span ref={bottomRef} />
                  </div>
                );
              }
        }
      ></Select>
    </div>
  );
};
